import React from 'react'
import clsx from 'clsx'

import { navigate } from 'gatsby'
import { Button } from '@/components/atoms/Button/Button'
import { getUrl } from '@/helpers/getUrl'
import * as styles from './PricingBox.module.css'

export function PricingBox({ title, price, price_info, currencySymbol, box_list, featured, buttons }: PricingBoxTypes) {
  return (
    <div
      className={clsx(
        'flex flex-col py-64 rounded-3xl text-white netbook:py-80',
        featured ? 'bg-primary-500' : 'bg-primary-700',
        buttons?.length > 1 ? 'px-64' : 'px-36 netbook:px-96',
        styles.box
      )}
    >
      <p className="text-bodyL text-center uppercase font-bold font-poppins mb-24">{title}</p>
      <p className="text-center uppercase font-bold font-poppins text-headingM-mobile h-40 netbook:text-headingM netbook:h-56">
        {currencySymbol && `${currencySymbol} ${price}`}
      </p>
      <p className="text-center font-bold font-poppins text-bodyL netbook:text-headingS mb-24 netbook:mb-40">
        {price_info}
      </p>
      <ul className="mb-32 tablet:mb-40">
        {box_list?.map(({ text, _uid }) => (
          <li className={clsx('mb-16 text-pBigger', styles.item)} key={_uid}>
            {text}
          </li>
        ))}
      </ul>
      <div
        className={clsx('mt-auto mx-auto', {
          flex: buttons?.length > 1
        })}
      >
        {buttons?.length > 0 &&
          buttons.map((button, index) => (
            <Button
              {...button}
              variant={button.variant || 'primary-large-inverted'}
              onClick={() => navigate(getUrl(button.url))}
              className={clsx(index === 1 ? 'ml-24' : '', 'font-poppins tracking-sm')}
              key={button._uid}
            >
              {button.text}
            </Button>
          ))}
      </div>
    </div>
  )
}
